import DomainAddIcon from "@mui/icons-material/DomainAdd";
import CreateProjects from "./Create";
import ListProjects from "./List";
import EditProjects from "./Edit";
import ShowProjects from "./Show";
//params
export const PROJECTS = "projects";
//permissions

export const resources = {
  isMenu: true,
  icon: <DomainAddIcon />,
  name: PROJECTS,
  title: "Проекти",
  list: <ListProjects />,
  create: <CreateProjects />,
  edit: <EditProjects />,
  show: <ShowProjects />,
  permission: "projects",
};

//api url
